import { BASE_API_URL_V2 } from "@/constants";
import store from "@/redux/store";
import fpFetch from "@/services/fpFetch";
import { Editor } from "@tiptap/react";
import { setProductTimeout } from "@/utils/productTimers";

const exportToHTML = async (
  editor: Editor,
  title?: string,
  includeLinks: boolean = true
) => {
  const workspaceId = store.getState().fpAppV4Data.workspaceId;
  if (!workspaceId) {
    throw new Error("No workspace ID found");
  }

  const response = await fpFetch(
    `${BASE_API_URL_V2}/api/v2/workspace/${workspaceId}/html?include_links=${includeLinks}`
  );

  if (!response.ok) {
    throw new Error(`Export failed: ${response.statusText}`);
  }

  const contentDisposition = response.headers.get("Content-Disposition");
  if (!contentDisposition) {
    throw new Error("No Content-Disposition header found in response");
  }

  const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
  if (!filenameMatch || !filenameMatch[1]) {
    throw new Error("Invalid Content-Disposition header format");
  }
  const filename = filenameMatch[1];

  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();

  setProductTimeout(() => {
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }, 100);
};

export default exportToHTML;
